import type { ReactElement } from 'react';

type Props = {
  label: string;
  value: string | number;
  isSelected: boolean;
  imageUrl: string;
  altText?: string;
  onClick: (value: string | number) => void;
  onAccountManagementPage?: boolean
};

function SelectableImageTile({
  label,
  value,
  isSelected,
  imageUrl,
  altText,
  onClick,
  onAccountManagementPage = false,
}: Props): ReactElement {
  return (
    <div
      role="button"
      tabIndex={0}
      className={`c-selectable-image-tile ${isSelected ? 'is-selected' : ''}`}
      onClick={() => onClick(value)}
      onKeyUp={(e) => e.key === 'Enter' && onClick(value)}
    >
      <img
        src={imageUrl}
        alt={altText ?? label}
        style={onAccountManagementPage ? { width: '50px', height: '50px' } : {}}
      />
      <h4 className="c-heading--brand-8 c-heading--no-margin">{label}</h4>
    </div>
  );
}

export default SelectableImageTile;
